import { autoinject, bindable } from "aurelia-framework";

@autoinject
export class HoverBoxCustomAttribute {
	@bindable({ primaryProperty: true }) contents: string;
	@bindable cssClass: string;

	private hoverBoxElementId = "hover-box";
	private showTimer = null;
	private hideTimer = null;

	constructor(private element: Element) {
	}

	private createHoverBoxElement(sourceRect: ClientRect): HTMLDivElement {
		const inLowerHalfOfScreen = sourceRect.top > (window.innerHeight / 2);
    const inRightHalfOfScreen = sourceRect.left > (window.innerWidth / 2);

		const box = document.createElement('div');
		box.id = this.hoverBoxElementId;
		box.classList.add(inLowerHalfOfScreen ? "upwards" : "downwards");

		if (this.cssClass) {
			box.classList.add(this.cssClass);
		}

		box.addEventListener("mouseover", this.onMouseEnterHoverBox);
		box.addEventListener("mouseleave", this.onMouseLeaveHoverBox);

		const innerHtml = document.createTextNode(this.contents);
		box.appendChild(innerHtml);
		document.body.appendChild(box);

		box.style.left = inRightHalfOfScreen
      ? `${Math.max(sourceRect.left - box.clientWidth + 10, 0)}px` // open left of the source
      : `${sourceRect.left}px` // open right of the source
    
		box.style.top = inLowerHalfOfScreen
			? `${Math.max(sourceRect.top - box.clientHeight - 5, 0)}px` // open above the source
			: `${sourceRect.bottom + 5}px`; // open below the source

		return box;
	}

	private hideBoxWithTimer(): void {
		clearTimeout(this.hideTimer); // nuke potential existing hide timer
		const box = document.getElementById(this.hoverBoxElementId);
		if (box && box.parentElement == document.body) {
			this.hideTimer = setTimeout(() => {
				box.removeEventListener("mouseover", this.onMouseEnterHoverBox);
				box.removeEventListener("mouseleave", this.onMouseLeaveHoverBox);
				if (box.parentElement == document.body) {
					document.body.removeChild(box);
				}
			}, 200);
		}
	}

	private onMouseLeave = () => {
		clearTimeout(this.showTimer);
		
		this.hideBoxWithTimer();
	};

	private onMouseEnter = () => {

		if (!this.contents) { return; }

		this.showTimer = setTimeout(() => {
			const sourceRect = this.element.getBoundingClientRect();
			this.createHoverBoxElement(sourceRect);
		}, 200);
	};

	private onMouseEnterHoverBox = () => {
		clearTimeout(this.hideTimer);
	};

	private onMouseLeaveHoverBox = () => {
		this.hideBoxWithTimer();
	};

	attached() {
		this.element.addEventListener("mouseover", this.onMouseEnter);
		this.element.addEventListener("mouseleave", this.onMouseLeave);
	}

	detached() {
		this.element.removeEventListener("mouseover", this.onMouseEnter);
		this.element.removeEventListener("mouseleave", this.onMouseLeave);
	}
}
